
import { computed, defineComponent, onBeforeMount, PropType, ref } from 'vue'
import { IdfButton, IdfCheckbox, IdfTextIcon } from '@invivodf/ui-kit'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { useUploadCondition } from '../../composables/useUploadCondition/useUploadCondition'
import fileService from '../../../file.service'

export default defineComponent({
  name: 'CUploadCsv',
  components: {
    IdfButton,
    IdfCheckbox,
    IdfTextIcon,
  },
  props: {
    csvProperties: {
      type: Object as PropType<{
        name: any
        full_path: string
        importType: string
        acceptedFiles: string
        importSectionTitle: string
        importSectionLabel: string
        uploadButtonLabel: string
      }>,
    },
    label: {
      type: String,
    },
    sectionTitle: {
      type: String,
    },
    hideDownloadTemplate: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const { uploadCondition, toggleUploadAllowed, hasCondition } = useUploadCondition()
    const file: any = ref(null)
    const acceptedFiles = computed(() => props.csvProperties?.acceptedFiles ?? '.csv')
    const error = ref('')
    const i18n = useI18nForVue2()
    const filename = computed(() => {
      return file.value?.name
    })

    const handleFileUpload = (event) => {
      // eslint-disable-next-line prefer-destructuring
      file.value = event.target.files[0]
      error.value = ''
    }
    const submitFile = async () => {
      if (await fileService.isUtf8(file.value)) {
        context.emit('send-file', file.value)
      } else {
        error.value = `${i18n.t('ctx.import.base__default-page-title-prop')} UTF8.`
      }
    }

    onBeforeMount(() => {
      if (uploadCondition.value.allowed) toggleUploadAllowed()
    })

    return {
      uploadCondition,
      toggleUploadAllowed,
      hasCondition,
      filename,
      error,
      handleFileUpload,
      submitFile,
      acceptedFiles,
    }
  },
})
